import { useCallback, useMemo, useState } from 'react';
import { safeParse } from '../utils';
import { Project } from '../types';
import { STORAGE_PROJECT, STORAGE_FILES, STORAGE_WORKING } from '../constants';

export function useProjectsState(defaultProject: string, branchesList: string[]) {
  const [projects] = useState<Project[]>(() => {
    const saved = safeParse<Project[]>(localStorage.getItem('atlas-ide:v2:projects'));
    return saved && saved.length ? saved : [{ id: defaultProject, label: `Project ${defaultProject}` }];
  });
  const [activeProject, setActiveProject] = useState<string>(localStorage.getItem(STORAGE_PROJECT) || defaultProject);
  const [projectOverride, setProjectOverride] = useState<string>(localStorage.getItem(STORAGE_PROJECT) || defaultProject);
  const [branches] = useState(branchesList);
  const [activeBranch, setActiveBranch] = useState<string>(localStorage.getItem('atlas-ide:v2:branch') || branchesList[0]);

  const applyProjectOverride = useCallback(
    (value: string) => {
      const trimmed = value.trim();
      if (!trimmed) return null;
      setActiveProject(trimmed);
      setProjectOverride(trimmed);
      localStorage.setItem(STORAGE_PROJECT, trimmed);
      return trimmed;
    },
    []
  );

  const projectCaches = useMemo(() => {
    const files = safeParse<Record<string, string>>(localStorage.getItem(`${STORAGE_FILES}:${activeProject}`)) || {};
    const working = safeParse<Record<string, string>>(localStorage.getItem(`${STORAGE_WORKING}:${activeProject}`)) || {};
    return { files, working };
  }, [activeProject]);

  return {
    projects,
    activeProject,
    projectOverride,
    setProjectOverride,
    applyProjectOverride,
    branches,
    activeBranch,
    setActiveBranch,
    projectCaches,
  };
}
